import { ACTIONS } from './action.js';
import uuid from 'react-uuid';
import moment from "moment";

export default function reducer(state, action) {

  switch (action.type) {

      case ACTIONS.FETCH:
        return action.payload.map(event => {
          return {
            ...event,
            uuid: uuid(),
            start: moment(event.start),
            end: moment(event.end),
            reminders: event.reminders.map(reminder => {
              return {
                ...reminder,
                uuid: uuid(),
              }
            })
          }
        });

      case ACTIONS.CREATE:
        return [...state, action.payload];

      case ACTIONS.UPDATE:
        return state.map(event => {
          if (event.uuid === action.payload.uuid) {
            return action.payload;
          }

          return event;
        })

      case ACTIONS.DELETE:
        return state.filter(event => event.uuid !== action.payload.uuid);

      default:
        return state;
  }
}